import React from 'react';
import { Route } from 'react-router';
import { TestimonialsContainer } from './components/testimonials';

export default (
  <Route path="testimonials" component={TestimonialsContainer} />
);



// WEBPACK FOOTER //
// ./app/screens/App/screens/Testimonials/index.js